// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1h6Dq","disabled":"FileBtn_disabled__2efw6","warn":"FileBtn_warn__B65Gx","fade":"FileBtn_fade__3oITS"};